import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BordroYuklePage = () => {
  const [talepler, setTalepler] = useState([]);
  const [seciliTalep, setSeciliTalep] = useState('');
  const [dosyalar, setDosyalar] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [sonuc, setSonuc] = useState(null);

  const yukle = () => axios.get('/api/talepler/hepsi')
    .then(r => setTalepler(r.data.filter(t => t.durum === 'muhasebeci_bekleniyor')))
    .catch(console.error);

  useEffect(() => { yukle(); }, []);

  const handleDosya = e => {
    const s = Array.from(e.target.files);
    if (s.length > 3) { alert('En fazla 3 dosya'); return; }
    setDosyalar(s);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!seciliTalep || !dosyalar.length) { setSonuc({ tip: 'hata', mesaj: 'Talep ve dosya seçin.' }); return; }
    setYukleniyor(true); setSonuc(null);
    const fd = new FormData();
    dosyalar.forEach(d => fd.append('bordrolar', d));
    try {
      await axios.post('/api/talepler/' + seciliTalep + '/bordro', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setSonuc({ tip: 'basari', mesaj: 'Bordrolar yüklendi! Tüm belgeler personele gönderildi.' });
      setDosyalar([]); setSeciliTalep(''); yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata oluştu.' }); }
    finally { setYukleniyor(false); }
  };

  const fmt = t => t ? new Date(t).toLocaleDateString('tr-TR') : '-';

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>Bordro Yükle</h2>
        <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>HR tarafından onaylanan talepler için son 3 aylık bordroları yükleyin.</p>
      </div>

      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}

      <div className="card">
        <form onSubmit={handleSubmit}>
          <div className="form-group" style={{ marginBottom: '1.25rem' }}>
            <label>Personel / Talep Seçin *</label>
            {talepler.length === 0
              ? <div style={{ padding: '0.75rem', background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', fontSize: '14px', color: 'var(--yazi-ikincil)', border: '1px solid var(--border)' }}>
                  Bekleyen talep bulunmuyor.
                </div>
              : <select value={seciliTalep} onChange={e => setSeciliTalep(e.target.value)} required>
                  <option value="">-- Talep seçin --</option>
                  {talepler.map(t => <option key={t.id} value={t.id}>{t.ad} {t.soyad} — {t.gidilecek_ulke} ({fmt(t.olusturma_tarihi)})</option>)}
                </select>
            }
          </div>

          {seciliTalep && (
            <>
              <div className="alert alert-info" style={{ marginBottom: '1.25rem' }}>
                Bordroları yüklediğinizde standart belgelerle birlikte personele otomatik gönderilecektir.
              </div>
              <div className="form-group" style={{ marginBottom: '1.25rem' }}>
                <label>Son 3 Aylık Bordrolar (PDF, JPG, PNG) *</label>
                <label className="dosya-alan" htmlFor="bordrolar">
                  <input id="bordrolar" type="file" multiple accept=".pdf,.jpg,.jpeg,.png" onChange={handleDosya} />
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--gri-400)" strokeWidth="1.5" style={{ margin: '0 auto 8px', display: 'block' }}>
                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"/>
                  </svg>
                  <p>Dosya seçmek için tıklayın (maks. 3 dosya)</p>
                  {dosyalar.map((d, i) => <div key={i} style={{ fontSize: '13px', color: 'var(--yesil)', fontWeight: '500' }}>✓ {d.name}</div>)}
                </label>
              </div>
              <button type="submit" className="btn btn-primary" disabled={yukleniyor} style={{ width: '100%', padding: '0.75rem' }}>
                {yukleniyor ? 'Yükleniyor ve gönderiliyor...' : 'Bordroları Yükle ve Gönder'}
              </button>
            </>
          )}
        </form>
      </div>
    </div>
  );
};
export default BordroYuklePage;
